import { render, staticRenderFns } from "./videoimdet.vue?vue&type=template&id=61a62d5a&scoped=true&"
import script from "./videoimdet.vue?vue&type=script&lang=js&"
export * from "./videoimdet.vue?vue&type=script&lang=js&"
import style0 from "./videoimdet.vue?vue&type=style&index=0&id=61a62d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a62d5a",
  null
  
)

export default component.exports